export default __webpack_public_path__ + "static/media/no_disponible.dccf2b64.png";